<template>
  <div :class="cls">

    <component v-if="isAccessible" :is="componentType" :config="config" :height="height"></component>
  </div>
</template>

<script>
import ModuleGrid from '@/view-widgets/ModuleGrid';
import MyDutyWidget from './MyDutyWidget';
import ReadHistory from '@/view-widgets/ReadHistory';
import ToAcknowledge from '@/view-widgets/ToAcknowledge';
import ToRead from '@/view-widgets/ToRead';
import ModuleLinkList from '@/view-widgets/ModuleLinkList';
import NewsSelection from '@/view-widgets/NewsSelection';
import Favorites from '@/view-widgets/Favorites';
import DocumentsSelection from '@/view-widgets/DocumentsSelection';
import DocumentList from '@/view-widgets/DocumentList';
import ConfigurableDocumentList from '@/view-widgets/ConfigurableDocumentList';
import ModuleCarousel from '@/view-widgets/ModuleCarousel';
import ModuleBox from '@/view-widgets/ModuleBox';
import LatestNews from '@/view-widgets/LatestNews';
import Banner from '@/view-widgets/Banner';
import OnDutyNotification from '@/view-widgets/OnDutyNotification';
import ThurboAnmeldung from '@/view-widgets/ThurboAnmeldung';
import ShowWelcomeDialog from '@/view-widgets/ShowWelcomeDialog';
import MyDutyDetailWidget from './MyDutyDetailWidget.vue';
import CenteredModuleBox from '@/view-widgets/CenteredModuleBox';
import WorksheetNavigationWidget from '@/modules/customerVbzWorksheet/widgets/WorksheetNavigationWidget.vue';
export default {
  name: 'Widget',
  props: {
    config: Object,
    height: Number,
  },
  components: {
    WorksheetNavigationWidget,
    MyDutyWidget,
    LatestNews,
    CenteredModuleBox,
    ModuleBox,
    ModuleGrid,
    ModuleCarousel,
    ToAcknowledge,
    ToRead,
    ReadHistory,
    ModuleLinkList,
    NewsSelection,
    DocumentsSelection,
    ConfigurableDocumentList,
    DocumentList,
    Favorites,
    Banner,
    OnDutyNotification,
    ThurboAnmeldung,
    MyDutyDetailWidget,
    ShowWelcomeDialog,
  },
  computed: {
    componentType() {
      return this.config.type;
    },
    isAccessible() {
      //TODO:Implement
      return true;
    },
    cls() {
      if (this.config.padding !== 0 && !this.config.padding) return 'pa-0 ma-0 pa-sm-2';
      return null;
    },
    style() {
      if (this.config.padding) return { padding: this.config.padding };
      return {};
    },
  },
};
</script>
